import { downloadFile } from "@/utilities/download-helper";
import { Monitoring } from "@/utilities/monitoring";
import axios from 'axios';
import apiClient from "./api";
import { getFilename } from "@/utilities/export-helper";

export const generateExcel = (organizationId: number, projectId: number, prefix = "aufnahmen", locale = "de") => {
    const filename = getFilename(prefix);
    // TODO: use AbortController when available with axios ^0.22.0
    const cancelToken = axios.CancelToken.source();
    const call = apiClient.post("/generate-excel", { organizationId, projectId, filename, locale }, { responseType: "blob", cancelToken: cancelToken.token })
        .then((response) => {
            //TODO: consolidate with useDownloadHelper, did not want to import the composable here
            downloadFile(response.data, `${filename}.xlsx`, "application/vnd.ms-excel");
        }).catch((error: any) => {
            Monitoring.chainError("Excel export failed", error);
        });
    return { call, abort: cancelToken.cancel };
};